
function getCurrentYear (time) {
    if (!time) return 
    return new Date(time).getFullYear()
}

function getLastYear (time) {
    return getCurrentYear(time) - 1
}

function formatTime (timeStamp) {
    if (!timeStamp) return 
    let time = new Date(timeStamp)
    let year = time.getFullYear()
    let m = time.getMonth() + 1
    let month = m < 10 ? '0' + m : m 
    let d = time.getDate()
    let date = d < 10 ? '0' + d : d 
    return `${year}-${month}-${date}`
}

function getYearMonth (time) {
    let date = new Date(time)
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    month = month < 10 ? '0' + month : month
    return `${year}-${month}`
}

function getDateRangeByDateType (dateType) {
    let date = new Date()
    let nowTimeStamp = date.getTime()
    let dayTimeStamp = 1000 * 60 * 60 * 24
    let today = date.getDay() - 1
    today = today < 0 ? 6 : today
    let toDate = date.getDate()
    let startDate
    let endDate
    if (dateType == 1) {
        // 今日
        startDate = formatTime(nowTimeStamp)
        endDate = formatTime(nowTimeStamp)
    } else if (dateType == 2) {
        // 昨日
        startDate = formatTime(nowTimeStamp - dayTimeStamp)
        endDate = formatTime(nowTimeStamp - dayTimeStamp)
    } else if (dateType == 3) {
        // 近7日
        startDate = formatTime(nowTimeStamp - dayTimeStamp * 7)
        endDate = formatTime(nowTimeStamp - dayTimeStamp)
    } else if (dateType == 4) {
        // 近30日
        startDate = formatTime(nowTimeStamp - dayTimeStamp * 30)
        endDate = formatTime(nowTimeStamp - dayTimeStamp)
    } else if (dateType == 5) {
        // 近90日
        startDate = formatTime(nowTimeStamp - dayTimeStamp * 90)
        endDate = formatTime(nowTimeStamp - dayTimeStamp)
    } else if (dateType == 6) {
        // 本周
        startDate = formatTime(new Date().setDate(toDate - today))
        endDate = formatTime(date)
    } else if (dateType == 7) {
        // 上周
        startDate = formatTime(new Date().setDate(toDate - 7 - today))
        endDate = formatTime(new Date().setDate(toDate - today - 1))
    } else if (dateType == 8) {
        // 本月
        startDate = formatTime(new Date(date.getFullYear(), date.getMonth(), 1))
        endDate = formatTime(date)
    } else if (dateType == 9) {
        // 上月
        startDate = formatTime(new Date(date.getFullYear(), date.getMonth() - 1, 1))
        endDate = formatTime(new Date(date.getFullYear(), date.getMonth(), 0))
    } else if (dateType == 10) {
        startDate = `${date.getFullYear()}-01-01`
        endDate = formatTime(date)
    } else if (dateType == 11) {
        // 近60日
        startDate = formatTime(nowTimeStamp - dayTimeStamp * 60)
        endDate = formatTime(nowTimeStamp - dayTimeStamp)
    } else if (dateType == 12) {
        // 近180日
        startDate = formatTime(nowTimeStamp - dayTimeStamp * 180)
        endDate = formatTime(nowTimeStamp - dayTimeStamp)
    } else if (dateType == 13) {
        // 近360日
        startDate = formatTime(nowTimeStamp - dayTimeStamp * 360)
        endDate = formatTime(nowTimeStamp - dayTimeStamp)
    }
    return { startDate, endDate }
}
const DATE_TEXT = {
    '1': '今日',
    '2': '昨日',
    '3': '过去7日',
    '4': '过去30日',
    '5': '过去90日',
    '6': '本周',
    '7': '上周',
    '8': '本月',
    '9': '上月',
    '10': '今年至今'
}

function changeOrientation(type) {
    // type 1 横屏 2 竖屏
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('android')) {
      window.supapp.changeOrientation(type)
    } else if (userAgent.includes('iphone')) {
        // document.title = 'iphone'
      window.webkit.messageHandlers.changeOrientation.postMessage({ type })
    }
}

function mobHandle (event, eventName) {
    let userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('android')) {
        window.supapp[event](JSON.stringify({eventName}))
    } else if (userAgent.includes('iphone')) {
        window.webkit.messageHandlers[event].postMessage({ eventName })
    }
}

function formatCustomDate (dateRange) {
    return dateRange.map(dateString => {
        return dateString.replace(/\-/g, '/')
    }).join('-')
}

function formatNumber (number) {
    if (number == undefined) {
        return ''
    }
    const arr = String(number).split('.')
    const int = arr[0].split('')
    const fraction = arr[1] || ''
    let num = ''
    int.reverse().forEach((v,i) => {
        if (i !== 0 && i % 3 === 0) {
            num = v + ',' + num
        } else {
            num = v + num
        }
    })
    return num + (!!fraction ? '.' + fraction : '')
}
function urlParams (url, params) {
    let paramsStr = ''
    Object.keys(params).forEach(key => {
        let str = `${key}=${params[key]}&`
        paramsStr += str
    })
    return `${url}?${paramsStr}`
}

export default {
    getCurrentYear,
    getLastYear,
    formatTime,
    getYearMonth,
    getDateRangeByDateType,
    changeOrientation,
    mobHandle,
    DATE_TEXT,
    formatCustomDate,
    formatNumber,
    urlParams
}